<template>
  <div class="link-class">
    <span class="index-class">{{ index }}</span>
    <span class="a-class text-truncate text-no-wrap">
       <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <a :href="href" target="_blank" v-bind="attrs"
             v-on="on">
            {{ title }}
          </a>
        </template>
        <span>{{ title }}</span>
      </v-tooltip>
    </span>
    <span class="hot-class">
      {{ hot }}
    </span>
  </div>
</template>

<script>
export default {
  name: "Link",
  // components: {v-link},
  props: {
    index: undefined,
    href: undefined,
    title: undefined,
    hot: undefined
  }
}
</script>

<style scoped>
a {
  text-decoration: none;
  cursor: pointer;
  outline: none;
  color: inherit;
}

.index-class {
  display: inline-block;
  min-width: 25px;
}

.a-class {
  flex: 1;
}

.hot-class {
  margin-left: 30px;
}

.link-class {
  display: flex;
  align-items: center;
  height: 25%;
  min-height: 32px;
  line-height: 32px;
  font-size: 15px;
}
</style>
